const LANDING_PAGES = [
    {
        pathname: '/summer-camps/massachusetts',
        heading: 'Summer Camps in Massachusetts',
        title: 'Summer Camps in Massachusetts | SnapCamp',
        description:
            'Discover summer camps in Massachusetts on SnapCamp. Browse trusted programs, compare locations and sessions, and find the right fit for your family.',
        keywords:
            'summer camps in massachusetts, kids camps in massachusetts, massachusetts summer camp marketplace, camps for kids in massachusetts',
        intro:
            'Explore kids summer camps across Massachusetts with one search experience built for families. Compare listings, locations, photos, and session details without jumping across dozens of separate camp sites.',
        body: [
            'SnapCamp helps parents discover camps by city, activity, age range, and season so it is easier to narrow down the best options.',
            'Use these Massachusetts listings as an entry point, then refine by dates, camper age, and category to find the right program faster.',
        ],
    },
    {
        pathname: '/summer-camps/boston',
        heading: 'Summer Camps in Boston',
        title: 'Summer Camps in Boston | SnapCamp',
        description:
            'Browse summer camps in Boston on SnapCamp. Compare trusted kids camp listings, nearby programs, and upcoming sessions in one place.',
        keywords:
            'summer camps in boston, kids camps in boston, boston summer camp marketplace, camps near boston',
        intro:
            'Find Boston-area summer camps with a search page built for families. Review nearby camp listings, compare offerings, and explore options around the city from one marketplace view.',
        body: [
            'Instead of starting from scratch each time, use this Boston landing page to browse real listings and then refine by age, dates, and camp type.',
            'Families can compare programs more quickly while camp operators gain a clearer discovery path from search to listing.',
        ],
    },
    {
        pathname: '/kids-camps/boston',
        heading: 'Kids Camps in Boston',
        title: 'Kids Camps in Boston | SnapCamp',
        description:
            'Explore kids camps in Boston on SnapCamp. Compare activities, nearby camp listings, and age-appropriate summer programs for children.',
        keywords:
            'kids camps in boston, children camps in boston, boston summer programs for kids, family camp marketplace boston',
        intro:
            'Browse kid-focused camp options in Boston with one search page designed to surface programs parents actually want to compare.',
        body: [
            'Use this page to discover children\'s camps in Boston, then narrow results by age, dates, and category as you explore the marketplace.',
        ],
    },
    {
        pathname: '/summer-camps/cambridge',
        heading: 'Summer Camps in Cambridge',
        title: 'Summer Camps in Cambridge | SnapCamp',
        description:
            'Find summer camps in Cambridge on SnapCamp. Explore nearby programs, compare listings, and discover camps for kids in and around Cambridge.',
        keywords:
            'summer camps in cambridge, kids camps in cambridge, cambridge ma summer camps, camps near cambridge',
        intro:
            'This Cambridge landing page makes it easier to discover camp options near home, compare listings, and filter by the details that matter most to families.',
        body: [
            'Browse available camp listings for Cambridge-area families and refine by age, activity, and session timing from a single page.',
        ],
    },
    {
        pathname: '/summer-camps/somerville',
        heading: 'Summer Camps in Somerville',
        title: 'Summer Camps in Somerville | SnapCamp',
        description:
            'Browse summer camps in Somerville on SnapCamp. Compare nearby kids camp listings, locations, and sessions for families in the Somerville area.',
        keywords:
            'summer camps in somerville, kids camps in somerville, somerville ma camps, nearby summer camps somerville',
        intro:
            'Families in Somerville can use this page to discover nearby camps, compare options more quickly, and move from search to decision with less friction.',
        body: [
            'Start with local camp listings and refine by dates, age, or category to find the right fit for your child.',
        ],
    },
    {
        pathname: '/summer-camps/brookline',
        heading: 'Summer Camps in Brookline',
        title: 'Summer Camps in Brookline | SnapCamp',
        description:
            'Explore summer camps in Brookline on SnapCamp. Discover kids camp listings, compare nearby programs, and review session options in one place.',
        keywords:
            'summer camps in brookline, kids camps in brookline, brookline summer camps, camps near brookline',
        intro:
            'This Brookline landing page gives families a clearer starting point for discovering nearby camps and comparing programs side by side.',
        body: [
            'Browse real marketplace listings, then narrow results by session timing, camper age, and activity type.',
        ],
    },
    {
        pathname: '/summer-camps/newton',
        heading: 'Summer Camps in Newton',
        title: 'Summer Camps in Newton | SnapCamp',
        description:
            'Find summer camps in Newton on SnapCamp. Browse local camp listings, compare activities, and discover programs for kids near Newton.',
        keywords:
            'summer camps in newton, kids camps in newton, newton ma summer camps, nearby camps newton',
        intro:
            'Use this Newton camp landing page to explore nearby options, compare programs, and find listings that match your family\'s schedule and interests.',
        body: [
            'SnapCamp helps parents move from broad discovery to filtered camp results without losing context across multiple sites.',
        ],
    },
];

module.exports = {
    LANDING_PAGES,
};
